import { LoadingSection } from '#/components/LoadingSection/LoadingSection';
import { TileCarousel } from '#/components/TileCarousel/TileCarousel';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { CmsApiRecommendedActionsBlockData } from '#/modules/cms/api/types/blocks/CmsApiRecommendedActionsBlock';
import { useSearchLocationOrEmpty } from '#/modules/search/contexts/SearchContext';
import { useSearchAlgoliaRecommendedVolops } from '#/modules/search/hooks/useSearchAlgoliaRecommendedVolops';
import { searchGetVolopsRoutePath } from '#/modules/search/volops/routing/searchGetVolopsRoutePath';

type Props = {
  data: CmsApiRecommendedActionsBlockData;
};

export function CmsRecommendedActionsBlockContent({ data }: Props) {
  const { i18n, locale } = useI18n();

  const {
    headline,
    volopFunction,
    areaOfFocus,
    locale: recommendedLocale,
  } = data;

  const searchLocation = useSearchLocationOrEmpty();

  const { data: recommendedActions, isLoading } =
    useSearchAlgoliaRecommendedVolops(searchLocation, {
      volopFunction,
      areaOfFocus,
      locale: recommendedLocale,
    });

  if (isLoading) return <LoadingSection />;

  const additionalAnalyticsProps: Record<string, string> = {};

  if (volopFunction) additionalAnalyticsProps.volop_function = volopFunction;
  if (areaOfFocus) additionalAnalyticsProps.area_of_focus = areaOfFocus;
  if (recommendedLocale && recommendedLocale !== 'all')
    additionalAnalyticsProps.locale = recommendedLocale;

  return (
    <TileCarousel
      headline={headline}
      results={recommendedActions}
      seeAll={{
        text:
          /* TRANSLATORS: Link to actions search */
          i18n('See All Volunteer Opportunities'),
        action: {
          type: 'link',
          url: searchGetVolopsRoutePath({ locale, embedSearchWidgetId: null }),
        },
      }}
      listingType="ACTION"
      additionalAnalyticsProps={additionalAnalyticsProps}
    />
  );
}
